/* global axios */

import ApiClient from './ApiClient';

class AccountActions extends ApiClient {
  constructor() {
    super('actions', { accountScoped: true });
  }

  // goalProfileKeep (optional): which customer profile the merged contact keeps,
  // 'newest' | 'base' | 'mergee'. Left out, the backend keeps the newest value per field.
  merge(parentId, childId, goalProfileKeep) {
    const payload = {
      base_contact_id: parentId,
      mergee_contact_id: childId,
    };
    if (goalProfileKeep) payload.goal_profile_keep = goalProfileKeep;
    return axios.post(`${this.url}/contact_merge`, payload);
  }
}

export default new AccountActions();
